/*
 * BlazePod × PostHog — page-level event instrumentation (Phase 1)
 *
 * Product-level events (product_viewed, product_added_to_cart) are emitted at
 * their source inside window.app.dl (assets/mt-main.js). This file covers the
 * page-scoped funnel events that have no single JS source point:
 *   - product_list_viewed (collection pages)
 *   - cart_viewed         (cart page)
 * Everything routes through window.BlazePodAnalytics.track (the consolidated
 * helper defined in snippets/bp-posthog.liquid) so events can later be
 * fanned out to additional destinations.
 */
(function () {
  function whenReady(cb) {
    if (window.BlazePodAnalytics && window.BlazePodAnalytics.track) return cb();
    var tries = 0;
    var timer = setInterval(function () {
      if (window.BlazePodAnalytics && window.BlazePodAnalytics.track) {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer); // give up after ~10s
      }
    }, 100);
  }

  function pageType() {
    return (window.theme && window.theme.pageType) || '';
  }

  function trackProductListViewed() {
    var header = document.querySelector('.mt-collection-header');
    var listName =
      (header && header.dataset && header.dataset.collection) ||
      document.title ||
      '';
    var cards = document.querySelectorAll('.mt-product-item[data-product]');
    window.BlazePodAnalytics.track('product_list_viewed', {
      list_name: listName,
      products_count: cards.length
    });
  }

  /*
   * Cart-note bridge: persist bp_did into the cart's attributes so it survives
   * the storefront -> checkout -> order-webhook boundary (Shopify checkout is a
   * sandbox where our first-party cookie/localStorage are not reliably readable).
   * Cart `attributes` surface as order.note_attributes and are readable by the
   * checkout Web Pixel. Written once per session (guarded via sessionStorage).
   */
  function ensureCartBridge(did) {
    if (!did) return;
    try { if (sessionStorage.getItem('bp_cart_bridge') === did) return; } catch (e) {}
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { bp_did: did } })
    })
      .then(function () { try { sessionStorage.setItem('bp_cart_bridge', did); } catch (e) {} })
      .catch(function () {});
  }

  function trackCartViewed() {
    // Pull authoritative totals from Shopify's cart endpoint (cents -> major units).
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.BlazePodAnalytics.track('cart_viewed', {
          value: (cart.total_price || 0) / 100,
          currency: cart.currency,
          items_count: cart.item_count
        });
      })
      .catch(function () {
        window.BlazePodAnalytics.track('cart_viewed', {});
      });
  }

  whenReady(function () {
    ensureCartBridge(window.BlazePodAnalytics.did);

    var pt = pageType();
    if (pt === 'collection') {
      trackProductListViewed();
    } else if (pt === 'cart') {
      trackCartViewed();
    }
  });
})();
